import React from 'react';
import { components } from 'react-select';
import { formatMultiPartLabel } from 'src/helpers';

const Option = ({ children, ...props }) => {
  const { Option } = components;

  const searchText = props && props.selectProps && props.selectProps.inputValue;
  const highlight = (needle, haystack) =>
    haystack.replace(new RegExp(needle.replace(/[-[\]{​​​​​​​​}​​​​​​​​()*+?.,\\^$|#\s]/g, '\\$&'), 'i'), str => `<strong>${str}</strong>`);
  const labelText = props.data.label !== null && props.data.label.length >= 1 ? highlight(searchText, props.data.label) : '';
  const labelParts = labelText.split('|');

  const labelContent = labelParts
    .map((label, i) => {
      if (i === 0) return label;
      return `<span style="display:block;padding:2px 0;font-size:12px;
      color:#888;">${label}</span>`;
    })
    .join('');

  const labelTitle = formatMultiPartLabel(labelText);
  const titleText = labelTitle.replace(/<\/?[^>]+(>|$)/g, '');

  return (
    <Option className={'Select-option'} {...props}>
      <div className="option-text" title={titleText} dangerouslySetInnerHTML={{ __html: labelContent }} />
    </Option>
  );
};

export default Option;
